/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Habensieweitereanregungenwnschebarrierefreiheitruheraumetc7Inputs */

const en__field_habensieweitereanregungenwnschebarrierefreiheitruheraumetc7 = /** @type {(inputs: _Field_Habensieweitereanregungenwnschebarrierefreiheitruheraumetc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`do you have any further suggestions for accessibility, space, etc.`)
};

const de__field_habensieweitereanregungenwnschebarrierefreiheitruheraumetc7 = /** @type {(inputs: _Field_Habensieweitereanregungenwnschebarrierefreiheitruheraumetc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haben Sie weitere Anregungen, Wünsche, Barrierefreiheit, Rüheraum, etc?`)
};

/**
* | output |
* | --- |
* | "do you have any further suggestions for accessibility, space, etc." |
*
* @param {_Field_Habensieweitereanregungenwnschebarrierefreiheitruheraumetc7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_habensieweitereanregungenwnschebarrierefreiheitruheraumetc7 = /** @type {((inputs?: _Field_Habensieweitereanregungenwnschebarrierefreiheitruheraumetc7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Habensieweitereanregungenwnschebarrierefreiheitruheraumetc7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_habensieweitereanregungenwnschebarrierefreiheitruheraumetc7(inputs)
	return de__field_habensieweitereanregungenwnschebarrierefreiheitruheraumetc7(inputs)
});
export { _field_habensieweitereanregungenwnschebarrierefreiheitruheraumetc7 as "_field_habenSieWeitereAnregungenWnscheBarrierefreiheitRuheraumEtc" }